import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {ExpandingTextAreaField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, _dispatch, props) => {
  const {text} = values;

  props.submitAction({noteText: text});
};

class EditNoteForm extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit(this.props.formName);
  };

  onKeyDown = event => {
    // textarea does not have keyCode property onChange, that's why we do this onkeyDown and exclude shift + enter
    if (event.keyCode === 13 && event.shiftKey === false) {
      event.preventDefault();
      this.triggerSubmit();
    }
  };

  render() {
    const {error, submitting, handleSubmit} = this.props;

    return (
      <form className="EditNoteForm" onSubmit={handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <Field
          name="text"
          className="editRoomNoteTextArea"
          component={ExpandingTextAreaField}
          minHeight="8rem"
          maxHeight="8rem"
          onKeyDown={this.onKeyDown}
        />
        <div className="buttons">
          <Button
            white
            className="cancelButton"
            type="button"
            onClick={this.props.hideEditNoteForm}>
            Cancel
          </Button>
          <Button
            className="editNoteButton"
            onClick={this.triggerSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Save
          </Button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (_state, props) => {
  const {message} = props;

  return {
    form: props.formName,
    initialValues: {
      text: message
    }
  };
};

const editNoteForm = reduxForm({
  onSubmit: formSubmit
})(EditNoteForm);

export default connect(mapStateToProps)(editNoteForm);
